<template>
  <div class="layout-segment">
    <div class="layout-segment__header">
      <h2 class="layout-segment__title">
        {{ getMainRegionName() }} - wczasy i wycieczki
      </h2>
    </div>
    <T1TabOffersPlaceholder v-if="!offersReady" />
    <template v-else>
      <a-row :gutter="[24, 24]" type="flex">
        <a-col
          :xs="24"
          :sm="12"
          :md="24"
          v-for="(item, idx) in oferty"
          :key="idx"
        >
          <T1TabOfferCard :oferta="getOfertyItems(idx)" />
        </a-col>
      </a-row>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import T1TabOfferCard from "../T1OfferCards/T1TabOfferCard";
import T1TabOffersPlaceholder from "../T1Placeholders/T1TabOffersPlaceholder.vue";
import { frontlinki } from "../frontlinki.js";
import * as CONFIG from "../config.js";

axios.defaults.withCredentials = false;

export default {
  props: {
    locid: String,
  },
  data: () => ({
    url: "/getoferty.json",
    dparams: "sort=3&order=ASC",
    oferty: [],
    offersReady: false,
    items: frontlinki.items,
  }),
  methods: {
    getOferty() {
      return axios
        .get(
          CONFIG.API_URL + this.url + "?" + this.dparams + this.getLocid(),
          null,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
            },
          }
        )
        .then((response) => {
          /*alert("DATA:" + response.data);
            alert("STATUS:" + response.status);
            alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOfertyItems(i) {
      return this.oferty[i];
    },
    getMainRegionName() {
      return CONFIG.panstwo_nazwapl;
    },
    getLocid() {
      if (this.locid != null && this.locid != "") {
        return "&locid=" + this.locid;
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.getOferty().then((data) => {
      //alert('OFERTY:' + JSON.stringify(data.page.response));
      this.oferty = data.page.response;
      this.offersReady = true;
    });
  },
  components: {
    T1TabOfferCard,
    T1TabOffersPlaceholder,
  },
};
</script>

<style lang="scss" scoped></style>
